import React, { useEffect, useRef } from "react";

import { ApiReportSuggestionGenerationStatusChoices } from "@api/graphql/types-and-hooks";
import { ProgressScreen } from "@components/ProgressScreen/ProgressScreen";
import { useIsQaScannerEnabled } from "@components/QaReview/hooks/useIsQaScannerEnabled";
import { useReviewData } from "@components/QaReview/hooks/useReviewData";
import { convertReadableString } from "@components/forms/utils";
import { useReport } from "@providers/ReportProvider";

export const PreThinkingScreen: React.FC = () => {
  const { report, reportQuery } = useReport();
  const isQaScannerEnabled = useIsQaScannerEnabled();
  const { status, start } = useReviewData();

  const hasCalledMutationRef = useRef(false);

  useEffect(() => {
    if (isQaScannerEnabled && status === null && !hasCalledMutationRef.current) {
      hasCalledMutationRef.current = true;
      start();
    }
  }, [isQaScannerEnabled, status, start]);

  const handleComplete = () => {
    reportQuery?.refetch();
  };

  return (
    <div className="flex w-full flex-col">
      <ProgressScreen
        title={`Preparing your ${convertReadableString(report.reportType)} for review…`}
        subtitle={`Leave this page open while we compile your ${convertReadableString(report.reportType)} inputs for review!`}
        duration={5}
        maxTimeout={7}
        isCompleted={status === ApiReportSuggestionGenerationStatusChoices.Completed}
        onComplete={handleComplete}
      />
    </div>
  );
};
